import { render, staticRenderFns, recyclableRender, components } from "./l-painter.vue?vue&type=template&id=17d4ba1d&"
var renderjs
import script from "./l-painter.vue?vue&type=script&lang=js&"
export * from "./l-painter.vue?vue&type=script&lang=js&"
import style0 from "./l-painter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/lime-painter/components/l-painter/l-painter.vue"
export default component.exports